class ProductCardForm extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback()
  }

  setupListeners() {
    super.setupListeners()

    this.els.submit.element.addEventListener('click', this.handleAddToCart.bind(this))

    if (this.els.variantChoice?.exists === true) {
      this.els.variantChoice.elements.forEach(variantChoice => {
        variantChoice.addEventListener('click', this.variantClick.bind(this))
      })
    }

    this.els.id.element.addEventListener('change', this.handleVariantChange.bind(this))
  }

  handleVariantChange(event) {
    if (this.els.id.element.value) {
      this.els.id.element.classList.add('psh-Card_VariantSelect-value')
    }
  }

  variantClick(event) {
    const variantId = event.currentTarget.dataset.variantId
    if (!variantId) return

    this.els.variantChoice.elements.forEach(variantChoice => {
      variantChoice.setAttribute('aria-current', variantChoice.dataset.variantId === variantId)
    })

    this.els.id.element.value = variantId

    if (this.els.monogram?.exists === true) {
      const url = new URL(this.els.monogram.element.href)
      const params = url.searchParams

      // Update the existing 'variant' and 'open-monogram' parameters
      params.set('variant', variantId)
      params.set('open-monogram', 'true')

      // Update the href with the new parameters
      this.els.monogram.element.href = url.toString()
    }
  }

  async handleAddToCart(event) {
    event.preventDefault()

    if (!this.els.id.element.value) return

    const cartItem = {
      id: this.els.id.element.value,
      quantity: 1,
    }

    try {
      const state = await window.BAO.Cart.addItem(cartItem)

      if ('sections' in state) this.renderSections(state.sections)
    } catch (err) {
      console.error('Error adding item to cart:', err)
    }
  }
}

if (!customElements.get('product-card-form')) {
  customElements.define('product-card-form', ProductCardForm)
}
